import { combineReducers } from "redux";
import AuthReducer from "./Auth/reducer";
import ExternalUserReducer from "./ExternalUser/reducer";
import ExternalUserSubUserReducer from "./ExternalUserSubUser/reducer";
import InternalUserReducer from "./InternalUser/reducer";
import EmployeeReducer from "./Employee/reducer";
import CustomerReducer from "./Customer/reducer";
import EquipmentReducer from "./Equipment/reducer";
import FromReducer from "./FromCreator/reducer";
import MethodReducer from "./Method/reducer";
import SampleReducer from "./SampleName/reducer";
import pageReducer from "./Pages/reducer";
import columnListReducer from './ColumnSetList/reducer'
import SampleListReducer from "./SampleList/reducer";
import RoleAndPermissionReducer from "./Roles&permission/reducer";
import ReportBuilderReducer from "./ReportBuilder/reducer";
import Service from "./service/reducer";
import CustomOrderReducer from "./CustomerOrder/reducer";
import WorkorderReducer from "./WorkOrder/reducer";
import MangageReducer from "./ManageJob/reducer";
import jobsReducer from "./Job/reducer";
import dataEntryReducer from "./DataEntry/reducer";
import EquipmentsServiceReducer from "./EquipmentService/reducer";
import ExpiredItemsReducer from "./ExpiredItems/reducer";
import ReagentReducer from "./ReagentsAndChemicals/reducer";
import StoreReducer from "./StoreReducer/reducer";
import ReportReducer from "./Reports/reducer";
import GroupReducer from "./Groups/reducer";
import CalibrationReducer from "./Calibration/reducer";
import MaintenanceReducer from "./Maintenance/reducer";
import TechnicianReducer from "./Technicians/reducer";
import SubscriberReducer from "./subscriber/reducer";
import SubscriptionPlan from "./subscriptionPlan/reducer";
import AdminFromReducer from "./AdminFormList/reducer";
import CMSPageReducer from "./PageList/reducer";
import ContentPageReducer from "./PageContent/reducer";
import SiteSettingReducer from "./SiteSetting/reducer";
import GeneralInventoryReducer from "./GeneralInventory/reducer";
import UserProfileReducer from "./UserProfile/reducer";
import EmployeeFromReducer from "./EmployeeFormList/reducer";
import IdentificationRuleReducer from "./IdentificationRules/reducer";
import EmployeeDetailsReducer from "./EmployeeDetails/reducer";
import NonConformityReducerReducer from "./NonConformityReport/reducer";
import NonConformityReportTicketReducer from "./NonConformityTicketReview/reducer";
import ArchieveReducer from "./Archieve/reducer";
import AccommodationReducer from "./Accommodation/reducer";
import BuildingReducer from "./Building/reducer";
import ClientFromReducer from "./ClientFormList/reducer";
import ClientDetailsReducer from "./ClientDetails/reducer";
import VendorReducer from "./vendor/reducer";
import VendorFromReducer from "./VendorFormList/reducer";
import VendorDetailsReducer from "./VendorDetails/reducer";
import ApprovalListReducer from "./Approvallist/reducer";
import GlobalAppReducer from "./appGlobal/reducer";
import VendorCategoriesReducer from "./VendorCategories/reducer";
import VendorSubCategoriesReducer from "./VendorSubCategories/reducer";
import formBuilderReducer from "./FormBuilder/reducer";
import DocumentsReducer from "./Document/reducer";
import DocumentCalibrationReducer from "./DocumentCalibration/reducer";
import DocumentMaintenanceReducer from "./DocumentMaintenance/reducer";
import CustomReportReducer from "./CustomReports/reducer";
import QualityManagmentReducer from "./QualityManagment/reducer";
import SubQualityManagmentReducer from "./SubQualityManagment/reducer";
import QualityManualReducer from "./QualityManual/reducer";
import userActivityReducer from "./UserActivity/reducer";

import TechnicalDocumentReducer from "./TechnicalDocument/reducer";
import StandardDocumentReducer from "./StandardDocument/reducer";

import GeneraldocumentReducer from "./GeneralDocument/reducer";
import PrivatedocumentReducer from "./PrivateDocument/reducer";
import MasterNameListReducer from "./MasterNameList/reducer";
import LeadCustomerReducer from "./LeadCustomer/reducer";
import RequestsReducer from "./Request/reducer";
import LabVisitorReducer from "./LabVisitor/reducer";
import LogReducer from "./Log/reducer";
import ClientDocumentListReducer from "./ClientDocumentList/reducer";
import MethodPackagesReducer from "./MethodPackages/reducer";
import AdminUserReducer from "./AdminUsers/reducer";
import ManagmentReviewReducer from "./ManagementReview/reducer";
import InternalAuditReducer from "./InternalAudit/reducer";
import ExternalAuditReducer from "./ExternalAudit/reducer";
import TraningReducer from "./Traning/reducer";
import PlanTraningReducer from "./PlanTraining/reducer";
import ManageParticipantsReducer from "./ManageParticipants/reducer";
import IntraLabProgramReducer from "./IntraLaboratoryProgram/reducer";
import InterLabProgramReducer from "./InterLaboratoryProgram/reducer";
import PtProgramReducer from "./PTProgram/reducer";
import SampleCategoriesReducer from "./SampleCategories/reducer";
import ComplainReducer from "./complains/reducer";
import SuggestionReducer from "./suggestion/reducer";
import CustomerSurveyReducer from "./customersurvey/reducer";
import EmployeeEvaluationReducer from "./EmployeeEvaluation/reducer";
import VendorEvaluationReducer from "./VendorEvaluation/reducer";
import EquipmentEvaluationReducer from "./EquipmentEvaluation/reducer";
import RecurringSurveyReducer from "./RecurringSurvey/reducer";
import CRMReducer from './CertifiedReferenceMaterial/reducer';
import CalibrationDevicesReducer from "./CalibrationDevices/reducer";
import OrganizationProfileFromReducer from "./OrganizationProfileFormList/reducer";
import EquipmentFormReducer from "./EquipmentFormList/reducer";
import ClientEvaluationReducer from "./ClientEvaluation/reducer";
import ClientProjectsReducer from "./ClientProjects/reducer";
import PublicFormReducer from "./PublicFormList/reducer";
import QuotationReducer from "./Quotation/reducer";
import ClientRequestReducer from "./ClientRequest/reducer";
import poReducer from "./Po/reducer";
const appReducer = combineReducers({
  AppSetting: GlobalAppReducer,
  AdminFormBuilder: AdminFromReducer,
  Auth: AuthReducer,
  ExternalUser: ExternalUserReducer,
  ExternalUserSubUser: ExternalUserSubUserReducer,
  InternalUser: InternalUserReducer,
  Employee: EmployeeReducer,
  Customer: CustomerReducer,
  ClientFormBuilder: ClientFromReducer,
  Equipments: EquipmentReducer,
  FromBuilder: FromReducer,
  Method: MethodReducer,
  SampleName: SampleReducer,
  SampleList: SampleListReducer,
  Pages: pageReducer,
  ColumnList: columnListReducer,
  RoleAndPermission: RoleAndPermissionReducer,
  Service: Service,
  CustomerOrder: CustomOrderReducer,

  reportBuilder: ReportBuilderReducer,
  WorkOrder: WorkorderReducer,
  ManageJob: MangageReducer,
  Jobs: jobsReducer,
  DataEntry: dataEntryReducer,
  EquipmentService: EquipmentsServiceReducer,
  ExpiredItems: ExpiredItemsReducer,
  ReagentsAndChemicals: ReagentReducer,
  Store: StoreReducer,
  Reports: ReportReducer,
  Groups: GroupReducer,
  Calibration: CalibrationReducer,
  Maintenance: MaintenanceReducer,
  Technician: TechnicianReducer,
  Subscriber: SubscriberReducer,
  SubscriptionPlan: SubscriptionPlan,
  CMSPageList: CMSPageReducer,
  ContentPage: ContentPageReducer,
  SiteSetting: SiteSettingReducer,
  GeneralInventory: GeneralInventoryReducer,
  UserProfile: UserProfileReducer,
  EmployeeFormBuilder: EmployeeFromReducer,
  Identification: IdentificationRuleReducer,
  EmployeeDynamicDetails: EmployeeDetailsReducer,
  NonConformityReport: NonConformityReducerReducer,
  NonConfirmityTicket: NonConformityReportTicketReducer,
  archieve: ArchieveReducer,
  Accommodation: AccommodationReducer,
  Building: BuildingReducer,
  ClientDynamicDetails: ClientDetailsReducer,
  Vendor: VendorReducer,
  VendorFormBuilder: VendorFromReducer,
  VendorDynamicDetails: VendorDetailsReducer,
  ApprovalList: ApprovalListReducer,
  VendorCategories: VendorCategoriesReducer,
  SampleCategories: SampleCategoriesReducer,
  VendorSubCategories: VendorSubCategoriesReducer,
  FormBuilder: formBuilderReducer,
  Documents: DocumentsReducer,
  DocumentCalibration: DocumentCalibrationReducer,
  DocumentMaintenance: DocumentMaintenanceReducer,
  CustomReports: CustomReportReducer,
  QualityManagment: QualityManagmentReducer,
  SubQualityManagment: SubQualityManagmentReducer,
  QualityManual: QualityManualReducer,
  userActivity: userActivityReducer,
  TechnicalDocument: TechnicalDocumentReducer,
  StandardDocument: StandardDocumentReducer,
  GeneralDocument: GeneraldocumentReducer,
  PrivateDocument: PrivatedocumentReducer,
  MasterNameList: MasterNameListReducer,
  LeadCustomer: LeadCustomerReducer,
  Requests: RequestsReducer,
  LabVisitors: LabVisitorReducer,
  Logs: LogReducer,
  Pos: poReducer,
  Quotations: QuotationReducer,
  ClientRequests: ClientRequestReducer,

  ClientDocumentList: ClientDocumentListReducer,
  MethodPackages: MethodPackagesReducer,
  AdminUser: AdminUserReducer,
  ManagmentReview: ManagmentReviewReducer,
  InternalAudit: InternalAuditReducer,
  ExternalAudit: ExternalAuditReducer,
  Traning: TraningReducer,
  PlanTraining: PlanTraningReducer,
  ManageParticipants: ManageParticipantsReducer,
  IntraLabProgram: IntraLabProgramReducer,
  InterLabProgram: InterLabProgramReducer,
  PTProgram: PtProgramReducer,
  suggestion: SuggestionReducer,
  complain: ComplainReducer,
  CustomerSurvey: CustomerSurveyReducer,
  EmployeeEvaluation: EmployeeEvaluationReducer,
  VendorEvaluation: VendorEvaluationReducer,
  EquipmentEvaluation: EquipmentEvaluationReducer,
  ClientEvaluation: ClientEvaluationReducer,
  ClientProjects: ClientProjectsReducer,
  RecurringSurvey: RecurringSurveyReducer,
  CRM: CRMReducer,
  CalibrationDevices: CalibrationDevicesReducer,
  OrganizationProfileFormBuilder: OrganizationProfileFromReducer,
  PublicFormBuilder: PublicFormReducer,
  EquipmentFormBuilder: EquipmentFormReducer,
});

const rootReducer = (state, action) => {
	if (action.type === "SESSION_RESET") {
		return appReducer(undefined, { type: undefined });
	} else {
		return appReducer(state, action);
	}
};

const whitelist = ["AdminFormBuilder", "FromBuilder"];

export { rootReducer, whitelist };
